import { render, staticRenderFns } from "./ShopsTablePageUser.vue?vue&type=template&id=385ec635"
import script from "./ShopsTablePageUser.vue?vue&type=script&lang=js"
export * from "./ShopsTablePageUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports